import { message } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import config from "../config/index";
import { logout } from "./api";
// import { exit } from "../utils/localStorage";

const service = axios.create({});
service.interceptors.response.use(
  function (response) {
    if (response.data.code === 401) {
      // exit();
      logout()
      // window.history.go("/login");
      window.location.href = "/login";
      return;
    }

    if (response.data.code !== 200 && response.data.code !== 0) {
      message.error(response.data.msg);
      throw response.data;
    }
    // 对响应数据做点什么
    return response;
  },
  function (error) {
    if (error.response.data.code === 401) {
      // exit();
      // window.history.go("/login");
      logout()
      window.location.href = "/login";
      return message.error("登录超时，重新登录");
    }
    // 对响应错误做点什么
    // 这就比较灵性了，他们的错误描述字段竟然不是统一的
    error.response.data.message && message.error(error.response.data.message);
    error.response.data.msg && message.error(error.response.data.msg);
    return Promise.reject(error);
  }
);

service.interceptors.request.use(function (request) {
  request.url = config.apiPath + request.url;
  if (request.url.indexOf("/login") >= 0) {
    return request;
  }
  // const loginMsg = userStore.userMsg;
  let accessToken = localStorage.getItem('accessToken');
  if (accessToken === "undefined" || accessToken === "null") {
    accessToken = null;
  }
  const date = dayjs().format("YYYY-MM-DD HH:mm:ss");
  request.headers["Authorization"] = accessToken ? `Bearer ${accessToken}` : null;
  request.headers["X-date"] = date;
  request.headers["Content-Type"] = "application/json; charset=utf-8";
  return request;
});
const get = (url, params, option) => {
  return service({
    url: url,
    method: "get",
    params,
    ...option,
  });
};
const post = (url, data, option) => {
  return service({
    url: url,
    method: "post",
    data,
    ...option,
  });
};
const put = (url, data, option) => {
  return service({
    url: url,
    method: "put",
    data,
    ...option,
  });
};
const deletefn = (url, data, option) => {
  return service({
    url: url,
    method: "delete",
    data,
    ...option,
  });
};
const patch = (url, data, option) => {
  return service({
    url: url,
    method: "patch",
    data,
    ...option,
  });
};
const request = {
  get,
  post,
  put,
  deletefn,
  patch,
};
export default request;
